/**
 * CustomerLayout — the frame around most storefront pages.
 *
 * Renders navbar + footer + the floating cart bar + bottom nav once, with the
 * current page in the <Outlet />. The cart page uses a DIFFERENT, minimal
 * layout (no search navbar) — see App.jsx — because you asked for the cart to
 * have no top search bar.
 */

import { Outlet, ScrollRestoration, useLocation } from 'react-router-dom';
import { Navbar } from './Navbar';
import { Footer } from './Footer';
import { BottomNav } from './BottomNav';
import { CartBar } from './CartBar';

export function CustomerLayout() {
  const { pathname } = useLocation();
  const hasMinimalHeader = [
    '/profile',
    '/profile-details',
    '/orders',
    '/addresses',
    '/help',
  ].includes(pathname);

  return (
    <div className="flex min-h-dvh flex-col bg-canvas">
      {!hasMinimalHeader && <Navbar />}

      {/* pb leaves room for the fixed bottom nav + cart bar on mobile. */}
      <main className="flex-1 pb-24 lg:pb-4">
        <Outlet />
      </main>

      {/* The marketing footer belongs on the storefront pages only — it's out of
          place on the app-style account screens (Profile, Orders, Addresses…),
          which use the minimal header. */}
      {!hasMinimalHeader && <Footer />}
      <CartBar />
      <BottomNav />
      <ScrollRestoration />
    </div>
  );
}

export default CustomerLayout;
